export default {
    fields: [
        {
            key:"_selected",
            label: "",
            sortable: false,
            filter:false,
            _filter: false,
        },
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: true,
            active: true
        },
        {
            key: "lead_id",
            label: "lead_id",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "email",
            label: "email",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "cp",
            label: "cp",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "origin",
            label: "origin",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "status",
            label: "status",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "created_at",
            label: "created_at",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "message",
            label: "message",
            sorter: true,
            filter: false,
            _filter: true,
            active: true
        }

    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
}
